import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

export default ArrowUpwardIcon;
